import {SectionPaddingHalfBottom, SectionPadding, Section} from '@/section';
import {Grid, Row, Col} from '@/grid';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import Container from '@/container';
import PictureWrapper from '@/ui/images-wrapper';
import BoxGrid from '@/ui/box-grid';
import {H2, P, PNoMargin} from '@/typography';
import Link from '@/links';
import {withBgYellow50} from '@/hocs/withColors';
import {withMarginBottomXs} from '@/hocs/withSpacing';

const imgPath = '/static/images/developers/';
const DivYellow50 = withBgYellow50(SectionPadding);
const PMarginXs = withMarginBottomXs(PNoMargin);

const GridItemsArray = [
  {
    order: 1,
    type: 'image',
    imageUrl: 'sourcing',
    imageTypeFallback: 'jpg',
    alt: 'Sourcing image'
  },
  {
    order: 2,
    type: 'image',
    imageUrl: 'assessments',
    imageTypeFallback: 'png',
    alt: 'Assessments image'
  },
  {
    order: 3,
    type: 'box',
    title: 'Sourcing',
    copy: 'Help your customers send candidates directly from your sourcing tool into Workable for tracking.',
    url: '/developers/partner-program/sourcing'
  },
  {
    order: 4,
    type: 'box',
    title: 'Assessments',
    copy: 'Let customers set up tests from your platform directly within their Workable hiring process.',
    url: '/developers/partner-program/assessment'
  },
  {
    order: 5,
    type: 'image',
    imageUrl: 'video-interviews',
    imageTypeFallback: 'jpg',
    alt: 'Video interview image'
  },
  {
    order: 6,
    type: 'image',
    imageUrl: 'background-checks',
    imageTypeFallback: 'jpg',
    alt: 'Background check image'
  },
  {
    order: 7,
    type: 'box',
    title: 'Video interviews',
    copy: 'Help users create and run video interviews with candidates, right from within Workable.',
    url: '/developers/partner-program/video-interview'
  },
  {
    order: 8,
    type: 'box',
    title: 'Background checks',
    copy: 'Let customers request and run background checks through your service without leaving Workable.',
    url: '/developers/partner-program/background-check'
  },
  {
    order: 9,
    type: 'image',
    imageUrl: 'onboarding',
    imageTypeFallback: 'jpg',
    alt: 'Onboarding and HRIS image'
  },
  {
    order: 10,
    type: 'empty'
  },
  {
    order: 11,
    type: 'box',
    title: 'HRIS and new hire onboarding',
    copy: 'Help new hires get started faster by letting customers send candidate details directly to your platform.',
    url: '/developers/partner-program/hris-onboarding'
  }
];

const renderGridItem = ({type, imageUrl, imageTypeFallback, alt, title, copy, url}) => {
  if (type === 'image') {
    return (
      <PictureWrapper
        imgPath={imgPath}
        imageUrl={imageUrl}
        imageTypeFallback={imageTypeFallback || 'jpg'}
        altImage={alt}
      />
    );
  }

  if (type === 'box') {
    return (
      <BoxGrid backgroundColor="var(--brown100)" Url={url} UrlCopy="Learn more">
        <PMarginXs className="heading-3">{title}</PMarginXs>
        <P>{copy}</P>
      </BoxGrid>
    );
  }

  return null;
};

const PartnerProgramCategoriesSection = () => (
  <DivYellow50 id="partners-api">
    <SectionPaddingHalfBottom>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} lg={8}>
              <H2>The developer partner program</H2>
              <P>
                Workable helps companies manage their entire hiring process. Partner with us to
                connect your product with Workable users' hiring workflows. From finding candidates
                to bringing new hires onboard, Workable is used at every step of hiring.
              </P>
              <Link href="/partnership-program/apply" variant="cta-default">
                Submit partner application
              </Link>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPaddingHalfBottom>
    <Section>
      <Container>
        <Grid fluid>
          <GridLayout Col={2} lgCol={2} autoRows>
            {GridItemsArray.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <GridItem key={index} Order={item.order}>
                {renderGridItem(item)}
              </GridItem>
            ))}
          </GridLayout>
        </Grid>
      </Container>
    </Section>
  </DivYellow50>
);

export default PartnerProgramCategoriesSection;
